<mat-card>
    <mat-card-title class="mat-align-center text-primary text-center"> Valor do Cálculo </mat-card-title>
    <mat-card-content>
        <mat-form-field>
            <input
                matInput
                type="number"
                (keydown.enter)="confirm()"
                [(ngModel)]="valor"
                matNumberFormat="1.2-2"
                [placeholder]="'R$ '" />
        </mat-form-field>
        <button mat-button (click)="confirm()">Confirmar</button>
    </mat-card-content>
</mat-card>
